<ng-container *ngIf="sammelbestellerGruppen && sammelbestellerGruppen.length > 0">
  <div>Inhalt Komponente</div>
</ng-container>
<ng-container *ngIf="!sammelbestellerGruppen || sammelbestellerGruppen.length == 0">
  <div>Für diesen Essensteilnehmer sind keine Einrichtungsgruppen hinterlegt</div>
</ng-container>
